if (!customElements.get('wls-countdown')) {
    class WLSCountdown extends HTMLElement {
      constructor() {
        super();
        this.countdownIntervals = [];
      }
  
      /**
       * Lifecycle method called when the element is added to the DOM.
       * Initializes all countdown timers.
       *
       * @returns {void}
       */
      connectedCallback() {
        this.initializeCountdowns();
      }
  
      /**
       * Initialize all countdown timers
       *
       * @returns {void}
       */
      initializeCountdowns() {
        // The custom element itself is the countdown slide
        const slide = this;
        const dateStr = slide.getAttribute('data-countdown-date');
        const timeStr = slide.getAttribute('data-countdown-time') || '00:00';
        
        if (!dateStr) return;

        // Parse date and time
        const dateParts = dateStr.split('-');
        const [month, day, year] = dateParts.map(Number);
        const timeParts = timeStr.split(':');
        const [hours, minutes] = timeParts.map(Number);
        
        const targetDate = new Date(year, month - 1, day, hours || 0, minutes || 0, 0);
        
        const daysEl = slide.querySelector('.wls-countdown-days');
        const hoursEl = slide.querySelector('.wls-countdown-hours');
        const minutesEl = slide.querySelector('.wls-countdown-minutes');
        const secondsEl = slide.querySelector('.wls-countdown-seconds');
        
        if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

        // Update immediately
        this.updateCountdown(targetDate, daysEl, hoursEl, minutesEl, secondsEl, slide);

        // Update every second
        const interval = setInterval(() => {
          const shouldContinue = this.updateCountdown(targetDate, daysEl, hoursEl, minutesEl, secondsEl, slide);
          if (!shouldContinue) {
            clearInterval(interval);
          }
        }, 1000);

        this.countdownIntervals.push(interval);
      }
  
      /**
       * Update countdown display
       *
       * @param {Date} targetDate - The target date and time
       * @param {HTMLElement} daysEl - Days element
       * @param {HTMLElement} hoursEl - Hours element
       * @param {HTMLElement} minutesEl - Minutes element
       * @param {HTMLElement} secondsEl - Seconds element
       * @param {HTMLElement} slide - The slide container
       * @returns {boolean} - Returns false if countdown has expired
       */
      updateCountdown(targetDate, daysEl, hoursEl, minutesEl, secondsEl, slide) {
        const now = new Date();
        const difference = targetDate - now;
  
        if (difference <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          slide.classList.add('wls-countdown-expired');
          return false;
        }
  
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
  
        daysEl.textContent = String(days).padStart(2, '0');
        hoursEl.textContent = String(hours).padStart(2, '0');
        minutesEl.textContent = String(minutes).padStart(2, '0');
        secondsEl.textContent = String(seconds).padStart(2, '0');
  
        return true;
      }
  
      /**
       * Lifecycle method called when the element is removed from the DOM.
       * Cleans up all countdown intervals.
       *
       * @returns {void}
       */
      disconnectedCallback() {
        // Clear all countdown intervals
        this.countdownIntervals.forEach(interval => clearInterval(interval));
        this.countdownIntervals = [];
      }
    }
  
    window.customElements.define('wls-countdown', WLSCountdown);
  }

  // Set --announcement-bar-height CSS variables for all announcement bar sections
  (function setAnnouncementBarHeight() {
    const announcementBarSections = document.querySelectorAll('.wls-announcement-bar');
    if (announcementBarSections.length === 0) return;

    const updateHeights = () => {
      let totalHeight = 0;
      
      announcementBarSections.forEach((section, index) => {
        const height = section.offsetHeight;
        // Set individual height variable for each section
        document.documentElement.style.setProperty(
          `--announcement-bar-height-${index}`,
          `${height}px`
        );
        totalHeight += height;
      });

      // Set combined total height for backward compatibility
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${totalHeight}px`
      );
    };

    // Set initial heights
    updateHeights();

    // Update on resize for all sections
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(updateHeights);
      announcementBarSections.forEach((section) => {
        resizeObserver.observe(section);
      });
    } else {
      // Fallback for browsers without ResizeObserver
      window.addEventListener('resize', updateHeights);
    }
  })();
  